// src/components/AdminRoute.js
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = () => {
  const { currentUser, userRole, loading } = useAuth();

  // Enquanto o sistema verifica a autenticação, não mostramos nada
  if (loading) {
    return <div>Verificando permissões...</div>;
  }

  // Se o usuário estiver logado E tiver o cargo de 'admin', permite o acesso.
  // O <Outlet /> é o componente que renderiza a página filha (no nosso caso, o AdminLayout).
  if (currentUser && userRole === 'admin') {
    return <Outlet />;
  }

  // Se não atender às condições, redireciona para a página inicial.
  return <Navigate to="/" />;
};

export default AdminRoute;